import {
  SIGN_IN,
  SIGN_UP,
  SIGN_OUT,
  SET_USER_AVATAR,
  UPDATE_USER_INFO,
  SIGN_IN_LOADING_STATUS,
  SIGN_UP_LOADING_STATUS,
} from 'constants/actionTypes';

const defaultState = {
  user: {},
};

function authReducer(state = defaultState, action) {
  switch (action.type) {
    case SIGN_IN:
      return {
        ...state,
        user: action.payload,
      };
    case SIGN_UP:
      return {
        ...state,
        user: action.payload,
      };
    case UPDATE_USER_INFO:
      return {
        ...state,
        user: action.payload,
      };
    case SIGN_OUT: {
      window.localStorage.removeItem('mpToken');

      return state;
    }
    case SET_USER_AVATAR:
      return {
        ...state,
        user: {
          ...state.user,
          personalInfo: {
            ...state.user.personalInfo,
            avatar: action.payload,
          },
        },
      };
    case SIGN_IN_LOADING_STATUS:
    case SIGN_UP_LOADING_STATUS: {
      return {
        ...state,
        [action.type]: action.payload,
      };
    }
    default:
      return state;
  }
}

export default authReducer;
